import { AxiosRequestConfig } from 'axios';

import { State } from 'model/State';
import hamsClient from 'modules/hams';
import { selectHamsClientConfig } from 'modules/auth/selectors';

import { baseDownloadsApiUrl } from '../..';
import { getImpersonationHeader } from 'util/mac/helpers';

export const getFromHamsClient = async (
  remainingPath: string,
  state: State,
  params?: AxiosRequestConfig['params'],
) => {
  try {
    const config = selectHamsClientConfig(state);
    const impersonationHeader = getImpersonationHeader(state);

    return (
      await hamsClient.get(`${baseDownloadsApiUrl}${remainingPath}`, {
        ...config,
        headers: {
          ...config.headers,
          ...impersonationHeader,
        },
        params,
      })
    ).data;
  } catch (error) {
    return Promise.reject(error);
  }
};
